<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
*/

html, body{
    margin: 0;
}

#app {
  font-family: Roboto, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Noto Sans CJK SC, WenQuanYi Micro Hei, Arial, sans-serif;
  text-align: center;
  height: 100%;
}

/*.el-button{*/
    /*border-color: #D63246;*/
    /*color: #D63246;*/
/*}*/

/*.el-button:hover{*/
    /*border-color: #D63246;*/
    /*background-color: #f4dbdb;*/
    /*color: #D63246;*/
/*}*/

/*.el-button:focus{*/
    /*border-color: #D63246;*/
    /*background-color: #f4dbdb;*/
    /*color: #D63246;*/
/*}*/

/*.el-button--danger{*/
    /*background-color: #D63246;*/
    /*border-color: #D63246;*/
    /*color: #fff;*/
/*}*/

/*.el-button--danger:hover{*/
    /*background-color: #bf2134;*/
    /*border-color: #bf2134;*/
    /*color: #fff;*/
/*}*/

/*.el-button--danger:focus{*/
    /*background-color: #bf2134;*/
    /*border-color: #bf2134;*/
    /*color: #fff;*/
/*}*/

/*.el-step__icon{*/
    /*background-color: #c0c4cc;*/
/*}*/

/*.el-step__head.is-wait{*/
    /*color: #ffffff;*/
/*}*/

/*.el-step__head.is-finish{*/
    /*color: #ffffff;*/
    /*border-color: #d63246;*/
    /*cursor: pointer;*/
/*}*/

/*.el-step__title.is-finish{*/
    /*color: #d63246;*/
    /*cursor: pointer;*/
/*}*/

/*.el-step__title.is-finish:hover{*/
    /*font-weight: bold;*/
/*}*/

/*.el-step__head.is-finish .el-step__line{*/
    /*background-color: #d63246;*/
/*}*/

/*.el-step__head.is-process{*/
    /*color: #ffffff;*/
    /*border-color: #d63246;*/
/*}*/

/*.el-step__head.is-finish .el-step__icon{*/
    /*background-color: #d63246;*/
/*}*/

/*.el-step__head.is-process .el-step__icon{*/
    /*background-color: #d63246;*/
/*}*/

/*.el-step__title.is-process{*/
    /*color: #d63246;*/
/*}*/

/*.el-step__description.is-process{*/
    /*width: 30px;*/
    /*height: 30px;*/
    /*border-radius: 50%;*/
    /*border: 2px solid;*/
    /*border-color: #d63246;*/
    /*background-color: #fff;*/
    /*padding-right: 0;*/
    /*margin-top: -37px;*/
    /*position: relative;*/
    /*right: 39px;*/
/*}*/

/*.el-step__title.is-wait{*/
    /*color: #9b9b9b;*/
/*}*/

/*.el-step__icon{*/
    /*background-color: #9b9b9b;*/
/*}*/

/*.el-step__head.is-wait{*/
    /*border-color: #9b9b9b;*/
/*}*/

/*.el-select-dropdown__item.selected{*/
    /*color: #2d2d2d*/
/*}*/

/*.el-select .el-input.is-focus .el-input__inner{*/
    /*border-color: #c0c4cc;*/
/*}*/

/*.el-select .el-input__inner:focus{*/
    /*border-color: #c0c4cc;*/
/*}*/

/*.el-radio__input.is-checked .el-radio__inner{*/
    /*border-color: #2D92F7;*/
    /*background: #2D92F7;*/
/*}*/

/*.el-radio__input.is-checked+.el-radio__label{*/
    /*color: #2D92F7;*/
/*}*/

#nprogress .bar {
   background: #fff !important;
}

#nprogress .spinner-icon {
   border-top-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue